import {GoingUtils,AssertUtils} from 'goingutils';
import {_getGridWidAndHeight} from "../commonFun/CommonFun";

export default {
    name: "grid-mixins",
    data: function () {
        return {
            gridId: GoingUtils.getUUid(12),
            id: GoingUtils.getUUid(12),
        };
    },
    computed: {},
    props: {
        //请求类型
        methodType: {
            type: String,
            default: 'POST'
        },
        padding: {
            type: Number,
            default: 0
        },
        //动态计算宽度
        autoWidth: {
            type: Boolean,
            default: true
        },
        // 是否存在工具栏
        hasToolBar: {
            type: Boolean,
            default: false
        },
        //表格配置信息
        config: {
            type: Object,
            default: () => {
            }
        },
        paginType: {
            type: String,
            default: "default"
        },
        //是否分页
        hasPagin: {
            type: Boolean,
            default: false
        },
        //离顶部的高度
        topHeight: {
            type: Number,
            default: 0
        },
        //表格高度
        height: {
            type: [Number, String],
            default: 0
        },
        //表格宽度
        width: {
            type: [Number, String],
            default: 0
        },
        type: {
            type: String,
            default: "commonGrid"
        },
        //查询url
        queryUrl: {
            type: String,
            default: ""
        },
    },
    methods: {
        _getGridWidth(){
            let _width = "100%";
            if (this.width !== 0) {
                _width = this.width;
            }
            return _width;
        },
        _initCommonEvent(gridObj,vueObj){
            //如果为空 则重新赋值
            if (this.gridObj == null) {
                this.gridObj = gridObj;
            }

            //选择记录 将选择的记录值返回
            gridObj.attachEvent("onRowSelect", function (rowIds) {
                let rowRecord = gridObj.getRowRecord(rowIds);
                if (gridObj.moreSel) {
                    //获取批量选择的记录id集合
                    rowIds = gridObj.getSelectedRowIds();
                }
                vueObj.$emit("selRecord", {rowIds, rowRecord});
            });
            //选列的事件
            gridObj.attachEvent("onCheckbox", function (rowIds) {
                let rowRecord = gridObj.getRowRecord(rowIds);
                vueObj.$emit("selRecord", {rowIds, rowRecord});
            });

            //switch变更事件
            gridObj.attachEvent("onSwitchChange", function (rowId,colIndex,colValue) {
                vueObj.$emit("switchEvent", {rowId,colIndex,colValue});
            });


            //缓存该值
            if (this.topHeight != 0) {
                gridObj.topHeight = this.topHeight;
            }
        },
        //获取表格对象
        getGridObj() {
            return this.gridObj;
        },
        initGridParams(pWid, pHeight){
            let vueObj = this;
            $("#" + vueObj.gridId).css({width: pWid, height: pHeight});
            //如果标签中没有传入hasPagin 但配置中又设置了pagin则取配置中的
            if (this.hasPagin) {
                //是否存在分页 参数
                vueObj.config["hasPagin"] = this.hasPagin;
            }
            if (this.paginType!=='default') {
                vueObj.config["paginType"] = this.paginType;
            }
            if (this.autoWidth) {
                //是否存在分页 参数
                vueObj.config["autoWidth"] = this.autoWidth;
            }
            //初始化查询url
            if (AssertUtils.isNotEmpty(this.queryUrl)) {
                vueObj.config["queryUrl"] = this.queryUrl;
            }
            vueObj.config["backFun"]=(jsonObj)=>{
                vueObj.$emit("afterLoadData",jsonObj);
            };
        },
        // 改变表格的高度相关信息
        changeGridSize(height, flag) {
            let vueObj = this;
            let oldHeight = $("#" + vueObj.gridId).height();
            let gridObj = vueObj.getGridObj();
            if (!flag) {
                $("#" + vueObj.gridId).css({height: oldHeight + height});
            } else {
                $("#" + vueObj.gridId).css({height: oldHeight - height});
            }
            if (AssertUtils.isNotNull(gridObj)) {
                gridObj.setSizes();
            }
        },
        //      导出表格数据
        exportData(options) {
            let vueObj = this;
            if (vueObj.gridObj != null) {
                vueObj.gridObj.exportData(options);
            }
        },
        //重新调整表格的宽高
        resizeGridObj() {
            //重新计算表格的宽高
            let {pWid, pHeight} = _getGridWidAndHeight(
                this.id,
                this.hasPagin,
                this.topHeight,
                this.hasToolBar,
                this.padding
            );
            if (this.gridObj != null) {
                $("#" + this.gridId).css({width: pWid, height: pHeight});
                this.gridObj.setSizes();
            }
        },
        //后置初始化
        initAsyncCtl() {
            //获取宽度 和高度
            let {pWid, pHeight} = _getGridWidAndHeight(
                this.id,
                this.hasPagin,
                this.topHeight,
                this.hasToolBar,
                this.padding
            );
            this.initGridObj(pWid, pHeight);
            this.initFlag = true;
        },
        //获取当前选中的表格id
        getSelectedRowId() {
            if (this.gridObj != null) {
                return this.gridObj.getSelectedRowId();
            }
        },
        //获取表格id集合
        getSelectedRowIds() {
            if (this.gridObj != null) {
                return this.gridObj.getSelectedRowIds();
            }
        },

        //刷新表格
        reloadData(options) {
            if (this.gridObj != null) {
                this.gridObj.reloadData(options);
            }
        },
    },
    mounted() {
    },
    components: {}
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlMixins/GridMixins.js